// // TutorCard.jsx
// import { useState, useEffect, useMemo  } from 'react'
// import ReactStars from 'react-rating-stars-component'
// import { useNavigate } from 'react-router-dom'
// import aiImage from '../../Assets/images/AIImg.svg'
// import forwordicon from '../../Assets/images/Vector (2).png'
// import cartadded from '../../Assets/images/cartadded.png'
// import cartempty from '../../Assets/images/cartempty.png'
// import carttick from '../../Assets/images/carttick.svg'

// import { MapPin } from 'lucide-react'
// import { toast } from 'react-toastify'
// import { API_URL, IMG_PATH } from '../../server'
// import NextAvailableSlot, {
//   checkAvailability
// } from '../AvailableSlot/NextAvailableSlot' // <-- imported here
// import BotIntegration from '../BotIntegration/BotIntegration'
// import './tutorCard.css'

// const TutorCard = ({
//   details,
//   registerid,
//   handleOtherUserProfile,
//   getexpertsbysubject,
//   handleBookSession,
//   choosebutton,
//   updateBookmarkInParent,
//   isChatOpen, // 👈 new prop
//   onToggleChat, // 👈 new prop
//   setSubscriptionModal,
//   expertDetails,
// }) => {
//   const expertId = details.user_id || details.expert_id || details.expert_id || details.bot_id
//   const [isBookmarked, setIsBookmarked] = useState(details.isBookedMark)
//   const [aibotId, setaiBotId] = useState('')

//   // track subscription flag from sessionStorage
//   const [isSubscribed, setIsSubscribed] = useState(() => {
//     try {
//       const s = sessionStorage.getItem('subscription')
//       return s ? JSON.parse(s) : null
//     } catch (e) {
//       return null
//     }
//   })

//   const requireLogin = () => {
//     const reg = sessionStorage.getItem('registerid')
//     if (!reg) {
//       // Trigger the same modal as Flow screen
//       navigate('/', { state: true })
//       return false
//     }
//     return true
//   }

//   const truncateWords = (text, limit = 3) => {
//   if (!text) return "";
//   const words = text.split(" ");
//   if (words.length <= limit) return text;
//   return words.slice(0, limit).join(" ") + "...";
// };

//   const navigate = useNavigate()

//   // ✅ NEW: Sync local isBookmarked state with parent's details.isBookedMark prop
//   useEffect(() => {
//     setIsBookmarked(details.isBookedMark)
//   }, [details.isBookedMark])

//   // keep local flag in sync if sessionStorage already has subscription
//   useEffect(() => {
//     const s = sessionStorage.getItem('subscription')
//     if (s !== null) setIsSubscribed(JSON.parse(s))
//   }, [])

//   console.log("Full TutorCard details:", details);

//   // if (details?.user_id && details?.bot_id) {
//   //   console.log('AI Twin TutorCard details:', details)
//   // }

//   const getUser = () => {
//     const token = sessionStorage.getItem('token')
//     const registerid = sessionStorage.getItem('registerid')

//     const myHeaders = new Headers()
//     myHeaders.append('Content-Type', 'application/json')
//     myHeaders.append('Authorization', 'Bearer ' + token)

//     const raw = JSON.stringify({ _id: registerid })

//     const requestOptions = {
//       method: 'POST',

//       headers: myHeaders,
//       body: raw,
//       redirect: 'follow'
//     }

//     fetch(API_URL + 'getUsers', requestOptions)
//       .then(response => response.json())
//       .then(result => {
//         if (result.Status === true) {
//           sessionStorage.setItem(
//             'subscription',
//             JSON.stringify(result.data.profile.subscription)
//           )
//           console.log('getUsers result:', result)
//         }
//       })
//       .catch(error => console.error(error))
//   }

//   useEffect(() => {
//     getUser()
//   }, [])

//     const hasTiming = useMemo(() => {
//   const timings = expertDetails?.newTiming || details?.newTiming
//   return timings?.some(t => t?.slots?.some(slot => slot?.isBooked === false))
// }, [expertDetails?.newTiming, details?.newTiming])

// const canBook = useMemo(() => {
//   return hasTiming && details?.onlineOffline
// }, [hasTiming, details?.onlineOffline])

//   if (expertId === registerid) return null

//   const handleBookmark = () => {
//     if (!requireLogin()) return
//     const token = sessionStorage.getItem('token')

//     const myHeaders = new Headers()
//     myHeaders.append('Content-Type', 'application/json')
//     myHeaders.append('Authorization', 'Bearer ' + token)

//     const tutorId = details.user_id || details._id || details.expert_id || details.bot_id;

//     const raw = JSON.stringify({
//       user_id: registerid,
//       expert_id: tutorId
//     })

//     console.log('Bookmark Payload:', {
//       user_id: registerid,
//       expert_id: tutorId
//     })

//     const requestOptions = {
//       method: 'POST',
//       headers: myHeaders,
//       body: raw,
//       redirect: 'follow'
//     }

//     fetch(API_URL + 'bookMarkForUser', requestOptions)
//       .then(response => response.json())
//       .then(result => {
//         console.log('Bookmark API:', result)
//         if (result.Status) {
//           setIsBookmarked(!isBookmarked) // ✅ toggle local UI
//           if (updateBookmarkInParent) {
//             updateBookmarkInParent(tutorId) // ✅ match card update logic
//           }
//         } else {
//           console.error('Bookmark failed:', result.message)
//         }
//       })
//       .catch(error => console.error(error))
//   }

//   const toggleAiChatboxmodal = botId => {
//     if (!requireLogin()) return

//     const subsStr = sessionStorage.getItem('subscription')
//     const subs = subsStr ? JSON.parse(subsStr) : false
//     if (!subs) {
//       setSubscriptionModal(true)
//       return
//     }

//     setaiBotId(botId)
//     onToggleChat(botId)
//   }

//   return (
//     <>
//       <div
//         className='bg-white rounded-lg border border-[#D0D0D0] p-2 flex flex-col hover:shadow-md transition  w-full'
//         onClick={e => {
//           e.stopPropagation()
//           handleOtherUserProfile?.(details)
//         }}
//       >
//         <div className='flex gap-2  items-start w-full overflow-hidden'>
//           {/* LEFT */}
//           <div className='flex flex-col items-center justify-center p-2 text-center '>
//             <img
//               src={
//                 details.image
//                   ? `${IMG_PATH}${details.image}`
//                   : require('../../Assets/images/nomage.png')
//               }
//               className='profileimage mb-1'
//               alt='Profile'
//             />

//             <ReactStars
//               count={5}
//               value={
//                 details?.completeCount <= 3
//                   ? 5
//                   : Math.round(details?.rating || 0)
//               }
//               isHalf={false}
//               edit={false}
//               activeColor='#D9B65B'
//               classNames='ratingstart'
//               size={17.84}
//             />

//             <div className='flex text-xs font-bold text-gray-500 items-end'>
//               <MapPin size={15} />

//               <span
//                 className='text-[11px] max-w-[50px] truncate cursor-pointer'
//                 title={details.countryName || ''}
//               >
//                 {details.countryName || ''}
//               </span>
//             </div>
//           </div>

//           {/* MIDDLE */}
//           <div className='middle-col flex flex-col items-start justify-between overflow-x-hidden px-2 p-1'>
//             <div className='space-y-1'>
//               <h3 className='ctitle text-base truncate'>{details.name}</h3>
//               <p className='text-sm text-gray-600 truncate'>
//                 {truncateWords(details.yourOneLiner || 'Expert', 3)}
//               </p>
//               <p className='text-sm text-gray-600 truncate'>
//                 Speaks {details.languages?.join(', ') || 'English'}
//               </p>
//             </div>
//             <div
//               onClick={e => {
//                 e.stopPropagation()
//                 getexpertsbysubject?.(details?.mySubject)
//               }}
//               className='subject-button'
//             >
//               <span className='subject-text'>
//                 {details?.mySubject?.[0]?.trim() || 'No Subject'}
//               </span>
//               <img
//                 className='subject-icon w-2 h-2 ml-2 flex-shrink-0'
//                 src={forwordicon}
//                 alt='arrow'
//               />
//             </div>
//           </div>

//           <div className='right-col flex flex-col items-end justify-between min-w-[100px] p-1'>
//             <div className='flex items-center gap-[1px]'>
//               <img
//                 src={details.isBookedMark ? cartadded : cartempty}
//                 alt='Bookmark'
//                 className='w-5 h-5 cursor-pointer'
//                 onClick={e => {
//                   e.stopPropagation()
//                   handleBookmark()
//                 }}
//               />

//               {details.bot_id && !details.user_id ? (
//                 <img src={aiImage} className='w-6 h-6' alt='AIImage' />
//               ) : (
//                 <img src={carttick} className='w-6 h-6' alt='Tick' />
//               )}
//             </div>
//             <div className='text-[11px] text-gray-500 break-words max-w-[120px] whitespace-nowrap'>
//               <NextAvailableSlot
//                 // timings={details?.newTiming}
//                 timings={expertDetails?.newTiming || details?.newTiming}
//                 bot_id={details?.bot_id}
//                 botdata={details}
//                  hasTiming={hasTiming}
//               onlineOffline={details?.onlineOffline}
//               />
//             </div>

//             {choosebutton ? (
//               <button
//                 onClick={e => {
//                   e.stopPropagation()

//                   // ✅ Login check only
//                   if (!requireLogin()) return

//                   handleBookSession?.({
//                     ...details,
//                     bot_id: details.bot_id
//                   })
//                 }}
//                 className='booknow-button online-booknow'
//               >
//                 Choose
//               </button>
//             ) : details.bot_id && !canBook ? (
//               <button
//                 onClick={e => {
//                   e.stopPropagation()
//                   toggleAiChatboxmodal(details.bot_id)
//                 }}
//                 className={'booknow-button online-booknow'}
//               >
//                 {isChatOpen ? 'Close Chat' : 'Chat Now'}
//               </button>
//             ) : (
//               <button
//                 disabled={!canBook}
//                 onClick={e => {
//                   e.stopPropagation()

//                   if (!requireLogin()) return

//                   if (canBook) {
//                     handleBookSession?.(details)
//                   }
//                 }}
//                 className={`booknow-button ${
//                   canBook
//                     ? 'online-booknow'
//                     : 'offline-booknow'
//                 }`}
//               >
//                {hasTiming && details?.onlineOffline ? 'Book Now' : 'Away'}
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {isChatOpen && aibotId && (
//         <BotIntegration botId={aibotId} userId='maheshavm27@gmail.com' />
//       )}
//     </>
//   )
// }

// export default TutorCard

// // <button
// //   disabled={
// //     !(
// //       details.onlineOffline &&
// //       checkAvailability(details?.newTiming)
// //     )
// //   }
// //   // onClick={(e) => {
// //   //   e.stopPropagation();
// //   //   if (
// //   //     details.onlineOffline &&
// //   //     checkAvailability(details?.newTiming)
// //   //   ) {
// //   //     if (registerid === null) {
// //   //       navigate("/", { state: true });
// //   //     } else {
// //   //       handleBookSession?.(details);
// //   //     }
// //   //   }
// //   // }}
// //   // onClick={(e) => {
// //   //   e.stopPropagation();

// //   //   const subsStr = sessionStorage.getItem("subscription");
// //   //   const subs = subsStr ? JSON.parse(subsStr) : false;
// //   //   if (!subs) {
// //   //     if (typeof setSubscriptionModal === "function") {
// //   //       setSubscriptionModal(true);
// //   //     }
// //   //     return;
// //   //   }

// //   //   if (
// //   //     details.onlineOffline &&
// //   //     checkAvailability(details?.newTiming)
// //   //   ) {
// //   //     if (registerid === null) {
// //   //       navigate("/", { state: true });
// //   //     } else {
// //   //       handleBookSession?.(details);
// //   //     }
// //   //   }
// //   // }}

// //   onClick={(e) => {
// //     e.stopPropagation();

// //     // 1️⃣ Check login first
// //     if (!requireLogin()) return;

// //     // 2️⃣ Subscription check
// //     const subsStr = sessionStorage.getItem("subscription");
// //     const subs = subsStr ? JSON.parse(subsStr) : false;
// //     if (!subs) {
// //       setSubscriptionModal(true);
// //       return;
// //     }

// //     // 3️⃣ Actual booking logic
// //     if (
// //       details.onlineOffline &&
// //       checkAvailability(details?.newTiming)
// //     ) {
// //       handleBookSession?.(details);
// //     }
// //   }}
// //   className={`booknow-button ${
// //     details.onlineOffline && checkAvailability(details?.newTiming)
// //       ? "online-booknow"
// //       : "offline-booknow"
// //   }`}
// // >
// //   {details.onlineOffline && checkAvailability(details?.newTiming)
// //     ? "Book Now"
// //     : "Away"}
// // </button>
// // <button
// //   disabled={!details.onlineOffline}
// //   onClick={e => {
// //     e.stopPropagation()

// //     // 1️⃣ Login check
// //     if (!requireLogin()) return

// //     // 2️⃣ Subscription check
// //     const subsStr = sessionStorage.getItem('subscription')
// //     const subs = subsStr ? JSON.parse(subsStr) : false
// //     if (!subs) {
// //       setSubscriptionModal(true)
// //       return
// //     }

// //     // 3️⃣ Book session
// //     if (details.onlineOffline) {
// //       handleBookSession?.(details)
// //     }
// //   }}
// //   className={`booknow-button ${
// //     details.onlineOffline ? 'online-booknow' : 'offline-booknow'
// //   }`}
// // >
// //   {details.onlineOffline ? 'Book Now' : 'Away'}
// // </button>

// TutorCard.jsx
import { useState, useEffect, useMemo } from "react";
import ReactStars from "react-rating-stars-component";
import { useNavigate } from "react-router-dom";
import aiImage from "../../Assets/images/AIImg.svg";
import forwordicon from "../../Assets/images/Vector (2).png";
import cartadded from "../../Assets/images/cartadded.png";
import cartempty from "../../Assets/images/cartempty.png";
import carttick from "../../Assets/images/carttick.svg";
import moment from "moment-timezone";
import { MapPin } from "lucide-react";
import { toast } from "react-toastify";
import { API_URL, IMG_PATH } from "../../server";
import NextAvailableSlot, {
  checkAvailability,
} from "../AvailableSlot/NextAvailableSlot";
import BotIntegration from "../BotIntegration/BotIntegration";
import "./tutorCard.css";

const TutorCard = ({
  details,
  registerid,
  handleOtherUserProfile,
  getexpertsbysubject,
  handleBookSession,
  choosebutton,
  updateBookmarkInParent,
  isChatOpen,
  onToggleChat,
  setSubscriptionModal,
  expertDetails,
  viewerTimezone,
}) => {
  const expertId = details.user_id || details.expert_id || details.bot_id;
  const [isBookmarked, setIsBookmarked] = useState(details.isBookedMark);
  const [aibotId, setaiBotId] = useState("");

  const [isSubscribed, setIsSubscribed] = useState(() => {
    try {
      const s = sessionStorage.getItem("subscription");
      return s ? JSON.parse(s) : null;
    } catch (e) {
      return null;
    }
  });

  const requireLogin = () => {
    const reg = sessionStorage.getItem("registerid");
    if (!reg) {
      navigate("/", { state: true });
      return false;
    }
    return true;
  };

  const truncateWords = (text, limit = 3) => {
    if (!text) return "";
    const words = text.split(" ");
    if (words.length <= limit) return text;
    return words.slice(0, limit).join(" ") + "...";
  };

  const navigate = useNavigate();

  useEffect(() => {
    setIsBookmarked(details.isBookedMark);
  }, [details.isBookedMark]);

  useEffect(() => {
    const s = sessionStorage.getItem("subscription");
    if (s !== null) setIsSubscribed(JSON.parse(s));
  }, []);

  const getUser = () => {
    const token = sessionStorage.getItem("token");
    const registerid = sessionStorage.getItem("registerid");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({ _id: registerid });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "getUsers", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status === true) {
          sessionStorage.setItem(
            "subscription",
            JSON.stringify(result.data.profile.subscription),
          );
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    getUser();
  }, []);

  // FIX: always fall back to details if expertDetails is not passed (OtherUserProfile case)
  const hasTiming = useMemo(() => {
    const timings = expertDetails?.newTiming || details?.newTiming;
    return timings?.some((t) =>
      t?.slots?.some((slot) => slot?.isBooked === false),
    );
  }, [expertDetails?.newTiming, details?.newTiming]);

  const canBook = useMemo(() => {
    return hasTiming && details?.onlineOffline;
  }, [hasTiming, details?.onlineOffline]);

  if (expertId === registerid) return null;

  const handleBookmark = () => {
    if (!requireLogin()) return;
    const token = sessionStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const tutorId =
      details.user_id || details._id || details.expert_id || details.bot_id;

    const raw = JSON.stringify({
      user_id: registerid,
      expert_id: tutorId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "bookMarkForUser", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.Status) {
          setIsBookmarked(!isBookmarked);
          if (updateBookmarkInParent) {
            updateBookmarkInParent(tutorId);
          }
        } else {
          console.error("Bookmark failed:", result.message);
        }
      })
      .catch((error) => console.error(error));
  };

  const toggleAiChatboxmodal = (botId) => {
    if (!requireLogin()) return;

    const subsStr = sessionStorage.getItem("subscription");
    const subs = subsStr ? JSON.parse(subsStr) : false;
    if (!subs) {
      setSubscriptionModal(true);
      return;
    }

    setaiBotId(botId);
    onToggleChat(botId);
  };

  return (
    <>
      <div
        className="bg-white rounded-lg border border-[#D0D0D0] p-2 flex flex-col hover:shadow-md transition w-full"
        onClick={(e) => {
          e.stopPropagation();
          handleOtherUserProfile?.(details);
        }}
      >
        <div className="flex gap-2 items-stretch w-full overflow-hidden">
          {/* LEFT */}
          <div className="flex flex-col items-center justify-center p-2 text-center">
            <img
              src={
                details.image
                  ? `${IMG_PATH}${details.image}`
                  : require("../../Assets/images/nomage.png")
              }
              className="profileimage mb-1"
              alt="Profile"
            />
            <ReactStars
              count={5}
              value={
                details?.rating && details.rating > 0
                  ? Math.round(details.rating)
                  : 5
              }
              isHalf={false}
              edit={false}
              activeColor="#D9B65B"
              size={17.84}
            />
            <div className="flex text-xs font-bold text-gray-500 items-end">
              <MapPin size={15} />
              <span
                className="text-[11px] max-w-[50px] truncate cursor-pointer"
                title={details.countryName || ""}
              >
                {details.countryName || ""}
              </span>
            </div>
          </div>

          {/* MIDDLE
              KEY FIX: justify-between needs the column to have a real height.
              'items-stretch' on the parent row makes all columns stretch to
              the same height, so justify-between on middle-col actually works
              and pins the subject-button to the bottom on EVERY render.
          */}
          {/* <div className='middle-col flex flex-col justify-between items-start overflow-x-hidden px-2 p-1'> */}
          <div className="middle-col flex flex-col justify-between items-start overflow-x-hidden px-2 p-1 pb-3 flex-1 min-w-0">
            <div className="middle-top space-y-1">
              <h3 className="ctitle text-base truncate">{details.name}</h3>
              <p className="text-sm text-gray-600 truncate">
                {truncateWords(details.yourOneLiner || "Expert", 3)}
              </p>
              <p className="text-sm text-gray-600 truncate">
                Speaks {details.languages?.join(", ") || "English"}
              </p>
            </div>

            <div
              onClick={(e) => {
                e.stopPropagation();
                getexpertsbysubject?.(details?.mySubject);
              }}
              className="subject-button"
            >
              <span className="subject-text">
                {details?.mySubject?.[0]?.trim() || "No Subject"}
              </span>
              <img
                className="subject-icon w-2 h-2 ml-2 flex-shrink-0"
                src={forwordicon}
                alt="arrow"
              />
            </div>
          </div>

          {/* RIGHT
              KEY FIX: same — justify-between works because parent is items-stretch,
              giving this column a real height equal to the tallest sibling.
              right-bottom groups availability + button so they move together.
          */}
          {/* RIGHT */}
          {/* <div className='right-col flex flex-col justify-between items-end min-w-[100px] p-1'> */}
          <div className="right-col flex flex-col justify-between items-end min-w-[100px] p-1 pb-3">
            {/* TOP: bookmark + AI/tick icon + availability text together */}
            <div className="flex flex-col items-end gap-[2px]">
              <div className="flex items-center gap-[1px]">
                <img
                  src={details.isBookedMark ? cartadded : cartempty}
                  alt="Bookmark"
                  className="w-5 h-5 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBookmark();
                  }}
                />
                {details.bot_id && !details.user_id ? (
                  <img src={aiImage} className="w-6 h-6" alt="AIImage" />
                ) : (
                  <img src={carttick} className="w-6 h-6" alt="Tick" />
                )}
              </div>

              {/* Availability sits right below icons — no gap */}
              <div className="availability-text text-[11px] text-gray-500">
                <NextAvailableSlot
                  timings={expertDetails?.newTiming || details?.newTiming}
                  bot_id={details?.bot_id}
                  botdata={details}
                  hasTiming={hasTiming}
                  onlineOffline={details?.onlineOffline}
                  // viewerTimezone={viewerTimezone}

                  viewerTimezone={
                    viewerTimezone ||
                    expertDetails?.timezone ||
                    details?.timezone ||
                    moment.tz.guess()
                  }
                  tutorTimezone={
                    expertDetails?.timezone ||
                    details?.timezone ||
                    moment.tz.guess()
                  }
                />
              </div>
            </div>

            {/* BOTTOM: book button only */}
            <div className="right-bottom">
              {choosebutton ? (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!requireLogin()) return;
                    handleBookSession?.({
                      ...details,
                      bot_id: details.bot_id,
                    });
                  }}
                  className="booknow-button online-booknow"
                >
                  Choose
                </button>
              ) : details.bot_id && !canBook ? (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleAiChatboxmodal(details.bot_id);
                  }}
                  className="booknow-button online-booknow"
                >
                  {isChatOpen ? "Close Chat" : "Chat Now"}
                </button>
              ) : (
                <button
                  disabled={!canBook}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!requireLogin()) return;
                    if (canBook) {
                      handleBookSession?.(details);
                    }
                  }}
                  className={`booknow-button ${canBook ? "online-booknow" : "offline-booknow"}`}
                >
                  {hasTiming && details?.onlineOffline ? "Book Now" : "Away"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {isChatOpen && aibotId && (
        <BotIntegration botId={aibotId} userId="maheshavm27@gmail.com" />
      )}
    </>
  );
};

export default TutorCard;
